import { useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';

export const useIsIntakeFormEnabled = () => {
    const marketplace = useSelector(getMarketplace);

    return marketplace.intakeFormPreferences.enabled;
};
